import * as batchfileApi from '@/network/api/batchfile.api.js'

/** Get BatchFileTransfer List
@return { promise }
*/
export const requestBatchfileTransfersList = async (context, payload) => {
    const res = await batchfileApi.requestBatchfileTransfersList(payload)

    if (res) context.commit('SAVE_BATCHFILETRANSFER_LIST', { pageNumber: payload.pageNumber, data: res.data.data })

    return res
}

/** Get BatchFileTransfer Detail
@return { promise } BatchFileTransfer Detail request
*/
export const requestBatchfileTransferDetail = async (context, payload) => {
    const res = await batchfileApi.requestBatchfileTransferDetail(payload)

    return res
}

/** requests operations status list
@return { promise } - Status list request
*/
export const requestStatusList = async (context, payload) => {
    const res = await batchfileApi.requestBatchfilStatus()
    if (res) {
        const data = res.data.data
        context.commit('SAVE_STATUS_LIST', data)
    }
    return res
}

/* ***********************************************
*                   CLEAR ACTIONS                *
*********************************************** */
export const clearFeatureStates = async (context, payload) => {
    context.commit('CLEAR_FEATURE_STATE')
}
